import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a75e4568295d5001407eebd_1786113046613_550e903b/kavris/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a75e4568295d5001407eebd_1786113046613_550e903b/kavris/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a75e4568295d5001407eebd_1786113046613_550e903b/kavris/src/components/AppLayout.tsx");
